// Доступ разработчика к админ-странице: `?k=a-<ключ>`.
//
// Ключ сверяется с переменной окружения деплоя `ADMIN_KEY`, а не с таблицей:
// разработчик один, и заводить под него строку в базе — значит выдумывать
// учётную запись ради одного сравнения строк. Ставится командой
// `make admin-key` (PROD=1 — в прод).
//
// Как и ключ взрослого (src/lib/tutor.ts), не сохраняется и из адреса не
// вычищается: браузер может оказаться общим, а ссылка — единственный носитель.

/**
 * Приставка ключа разработчика. По ней main.tsx выбирает экран, не спрашивая
 * сервер; защиты в ней нет — сервер сверяет ключ целиком.
 */
export const ADMIN_PREFIX = "a-";

/** Ключ разработчика из ссылки. Пустая строка — открывали не им. */
export function readAdminKey(): string {
  try {
    const fromLink = new URLSearchParams(window.location.search).get("k");
    return fromLink !== null && fromLink.startsWith(ADMIN_PREFIX) ? fromLink : "";
  } catch {
    return "";
  }
}
